import Webcam, { WebcamRef } from './Webcam';

export default Webcam;
export type { WebcamRef };
